import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface GetWireTransferDocumentUrlArg {
    engagementId: number;
    documentId: number;
}

export const GetWireTransferDocumentUrl = createAsyncThunk(
    'flowOfFunds/getWireTransferDocumentUrl',
    async (arg: GetWireTransferDocumentUrlArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/Documents/${arg.documentId}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to retrieve document URL');
            }

            return response.data as string;
        } catch (error) {
            createNotification(
                'There was an error while retrieving the document.',
                'error'
            );
            throw error;
        }
    }
);
